import { type FunctionComponent } from 'react';
import { useFeature } from '../../../../hooks/features/features.hooks';
import { TextButton } from '../../../buttons';
import { Loading } from '../../../common-components/loading/loading.component';
import SlidersIcon from '../../../svgs/untitled-ui/sliders.svg';

export type FacetDrawerTitleProps = {
	title: string;
	containerClassName?: string;
	titleClassName?: string;
	hasFilters?: boolean;
	clearFacets?: () => void;
	loading?: boolean;
};

export const FacetDrawerTitle: FunctionComponent<FacetDrawerTitleProps> = ({
	title,
	containerClassName = '',
	titleClassName = '',
	hasFilters = false,
	clearFacets,
	loading = false
}) => {
	const isProjectCoverImageEnabled = useFeature('project-cover-image');

	return (
		<>
			<div className={containerClassName}>
				<div className={`flex items-center ${titleClassName}`}>
					{isProjectCoverImageEnabled === false && <SlidersIcon className="mr2" data-testid="SlidersIcon" />}
					<span>{title}</span>
				</div>
				{hasFilters && (
					<TextButton onClick={clearFacets} underline={false} className="ml3 ph2 pv3 f5 lh-title theme-primary-dark fade-in">
						Clear All
					</TextButton>
				)}
				{loading && (
					<div className="ml3 f3 self-center">
						<Loading />
					</div>
				)}
			</div>
		</>
	);
};
